/**
 * Client-side validation for the lead-capture form. This is a UX convenience only — the server
 * is the one place this data is actually trusted or persisted, and it validates independently
 * (CLAUDE.md: never trust client-calculated anything; common/security.md: validate at every
 * boundary, client and server both).
 */
export interface LeadFormValues {
  name: string;
  organizationName: string;
  email: string;
  phone: string;
  message: string;
}

const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function validateLeadForm(values: LeadFormValues): Record<string, string> {
  const errors: Record<string, string> = {};
  if (values.name.trim().length === 0) errors["name"] = "Enter your name.";
  if (values.organizationName.trim().length === 0) {
    errors["organizationName"] = "Enter your organization.";
  }
  if (values.email.trim().length === 0) {
    errors["email"] = "Enter an email address.";
  } else if (!EMAIL_PATTERN.test(values.email.trim())) {
    errors["email"] = "Enter a valid email address.";
  }
  return errors;
}
